import { render, staticRenderFns } from "./forgotpassword.vue?vue&type=template&id=5d5b6b9a&scoped=true"
import script from "./forgotpassword.vue?vue&type=script&lang=js"
export * from "./forgotpassword.vue?vue&type=script&lang=js"
import style0 from "./forgotpassword.vue?vue&type=style&index=0&id=5d5b6b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5b6b9a",
  null
  
)

export default component.exports